<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">


        <div class="col-lg-12">

            <div class="card">
                <div class=" card-header ">
                    <h5 class="font-medium election-title">📄 Arbitration Cases</h5>

                </div>
                <div class="card-body">

                    <form [formGroup]="targetForm" (ngSubmit)="getArbitrationCases()">
                        <div class="row align-items-end">

                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                                <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                                    <option value="">--Select--</option>
                                    <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                                        {{ circle?.sCircleName }}
                                    </option>
                                </select>
                                <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                                    class="text-danger small">
                                    Circle office is required
                                </div>
                            </div>


                            <!-- Block Office -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label">Block Office <span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="blockOffice">
                                    <option value="" selected>--Select--</option>
                                    <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                        {{ circle?.sBlockName }}
                                    </option>
                                </select>
                                <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                                    class="text-danger small">
                                    block Office is required
                                </div>
                            </div>

                            <!-- Financial Year -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label">Financial/Reporting Year <span
                                        class="text-danger">*</span></label>
                                <select class="form-control" formControlName="financialYear">
                                    <option value="">--Select--</option>
                                    <option *ngFor="let years of financialYears" [ngValue]="years">
                                        {{ years?.financialYear }}
                                    </option>
                                </select>
                                <div *ngIf="targetForm.get('financialYear')?.touched && targetForm.get('financialYear')?.invalid"
                                    class="text-danger small">
                                    Financial year is required
                                </div>
                            </div>

                            <!-- Submit -->
                            <div class="col-lg-12 text-end">
                                <button type="submit" class="btn btn-primary" [disabled]="targetForm.invalid">
                                    Get Report
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header d-flex justify-content-between align-items-center gap-1">
                    <h5 class="font-medium election-title">📄 Arbitration Cases Report</h5>
                    <button type="button" class="btn btn-primary btn-sm"
                        *ngIf="showAddButton  && (this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13)"
                        (click)="viewModel($event)">Add Data for {{currentMonth?.name}}</button>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                            <tbody>
                                <tr class="texture font-size-12">
                                    <th class="text-right" rowspan="3" style="width: 2%">S. N.</th>
                                    <th rowspan="3" style="width: 10%">Month</th>
                                    <th rowspan="2" class="text-center" colspan="2">Overdue at the begining of month
                                    </th>
                                    <th rowspan="2" class="text-center" colspan="2">Fresh Cases during the Month</th>
                                    <th rowspan="2" class="text-center" colspan="2">Cases Decided during the Month</th>
                                    <th rowspan="2" class="text-right" colspan="2">Balance at the end of the Month</th>
                                    <th class="text-center" colspan="6">Pendency</th>
                                    <th rowspan="3" class="text-center" style="width:3%">Action</th>
                                </tr>
                                <tr class="texture font-size-12">
                                    <th colspan="2" class="text-right">Less than 4 months</th>
                                    <th colspan="2" class="text-right">Above 4 months</th>
                                    <th colspan="2" class="text-right">Above 1 year</th>
                                </tr>
                                <tr class="texture font-size-12">
                                    <th class="text-right">No.</th>
                                    <th class="text-right">Amt. (in <i class="fa fa-inr fa-mr-0"></i>)</th>
                                    <th class="text-right">No.</th>
                                    <th class="text-right">Amt. (in <i class="fa fa-inr fa-mr-0"></i>)</th>
                                    <th class="text-right">No.</th>
                                    <th class="text-right">Amt. (in <i class="fa fa-inr fa-mr-0"></i>)</th>
                                    <th class="text-right">No.</th>
                                    <th class="text-right">Amt. (in <i class="fa fa-inr fa-mr-0"></i>)</th>
                                    <th class="text-right">No.</th>
                                    <th class="text-right">Amt. (in <i class="fa fa-inr fa-mr-0"></i>)</th>
                                    <th class="text-right">No.</th>
                                    <th class="text-right">Amt. (in <i class="fa fa-inr fa-mr-0"></i>)</th>
                                    <th class="text-right">No.</th>
                                    <th class="text-right">Amt. (in <i class="fa fa-inr fa-mr-0"></i>)</th>
                                </tr>
                                <!-- <tr>
                                    <td class="text-center">1.</td>
                                    <td>April, 2025</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-center no-wrap">
                                        <button type="button" class="btn btn-secondary btn-sm"
                                            title="Verified on 05/02/2025 3:39:00 PM"><i
                                                class="fa fa-lock"></i></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-center">2.</td>
                                    <td>May, 2025</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-right">0</td>
                                    <td class="text-right">0.00</td>
                                    <td class="text-center no-wrap">
                                        <div class="d-flex gap-1 align-items-center">
                                            <button type="button" class="btn btn-primary btn-sm"
                                                title="Click to Edit"><i class="fa fa-pencil-square-o"></i></button>
                                            <button type="button" class="btn btn-success btn-sm"
                                                title="Click to Verify"><i class="fa fa-check-square-o"></i></button>
                                            <button type="button" class="btn btn-danger btn-sm"
                                                title="Click to Delete"><i class="fa fa-trash-o"></i></button>
                                        </div>
                                    </td>
                                </tr> -->
                                <!-- Dynamic Rows -->
                                <ng-container *ngIf="rows && rows.length>0">
                                    <tr *ngFor="let c of rows; let i = index">
                                        <td class="text-center">{{ i + 1 }}.</td>
                                        <td>{{ getMonthName(c.month) }}</td>

                                        <td class="text-right">{{ c.overdue_No }}</td>
                                        <td class="text-right">{{ c.overdue_Amt | number:'1.2-2' }}</td>

                                        <td class="text-right">{{ c.fresh_No }}</td>
                                        <td class="text-right">{{ c.fresh_Amt | number:'1.2-2' }}</td>

                                        <td class="text-right">{{ c.decided_No }}</td>
                                        <td class="text-right">{{ c.decided_Amt | number:'1.2-2' }}</td>

                                        <td class="text-right">{{ c.balance_No }}</td>
                                        <td class="text-right">{{ c.balance_Amt | number:'1.2-2' }}</td>

                                        <td class="text-right">{{ c.pendency_Below4_No }}</td>
                                        <td class="text-right">{{ c.pendency_Below4_Amt | number:'1.2-2' }}</td>

                                        <td class="text-right">{{ c.pendency_4to12_No }}</td>
                                        <td class="text-right">{{ c.pendency_4to12_Amt | number:'1.2-2' }}</td>

                                        <td class="text-right">{{ c.pendency_Above1_No }}</td>
                                        <td class="text-right">{{ c.pendency_Above1_Amt | number:'1.2-2' }}</td>

                                        <td class="text-center no-wrap">
                                            <div class="d-flex gap-1 align-items-center">

                                                <ng-container
                                                    *ngIf="!c.isVerified && this.UserDetails?.roleId !==1; else verifiedBlock">
                                                    <button type="button" class="btn btn-primary btn-sm"
                                                        title="Click to Edit" (click)="editRow(c)">
                                                        <i class="fa fa-pencil-square-o"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        title="Click to Verify" *ngIf="this.UserDetails?.roleId ==13"
                                                        data-bs-toggle="modal" data-bs-target="#verifyConfirmModal"
                                                        (click)="setDeleteIndex(c?.caseDataId)">
                                                        <i class="bi bi-clipboard2-check"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-danger btn-sm"
                                                        title="Click to Delete" data-bs-toggle="modal"
                                                        data-bs-target="#deleteConfirmModal"
                                                        (click)="setDeleteIndex(c?.caseDataId)">
                                                        <i class="fa fa-trash-o"></i>
                                                    </button>
                                                </ng-container>
                                                <!-- Verified State -->
                                                <ng-template #verifiedBlock>
                                                    <button type="button" class="btn btn-primary btn-sm"
                                                        [title]="'Verified on ' + (c.verifiedOn ? (c.verifiedOn | date:'dd/MM/yyyy hh:mm:ss a') : '')">
                                                        <i class="bi bi-lock"></i>
                                                    </button>
                                                </ng-template>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>

                            </tbody>
                        </table>
                        <!-- Delete Confirmation Modal -->
                        <div class="modal fade" id="deleteConfirmModal" tabindex="-1"
                            aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button>
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to delete this Arbitration Case ?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-dismiss="modal">Cancel</button>
                                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="DeleteArbitrationData(deleteIndex)">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- verify Confirmation Modal -->
                        <div class="modal fade" id="verifyConfirmModal" tabindex="-1"
                            aria-labelledby="verifyConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Veriication</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to Verify?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                            (click)="this.deleteIndex = 0;">Cancel</button>
                                        <button type="button" (click)="VerifyArbitrationData(deleteIndex)"
                                            class="btn btn-success" data-bs-dismiss="modal"
                                            aria-label="Close">verify</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <table class="table table-bordered table-hover">
  <tbody>
    <tr class="texture font-size-12">
      <th class="text-right" rowspan="3" style="width: 2%">S. N.</th>
      <th rowspan="3" style="width: 10%">Month</th>
      <th rowspan="2" class="text-center" colspan="2">Overdue at the beginning of month</th>
      <th rowspan="2" class="text-center" colspan="2">Fresh Cases during the Month</th>
      <th rowspan="2" class="text-center" colspan="2">Cases Decided during the Month</th>
      <th rowspan="2" class="text-right" colspan="2">Balance at the end of the Month</th>
      <th class="text-center" colspan="6">Pendency</th>
      <th rowspan="3" class="text-center" style="width:3%">Action</th>
    </tr>
    <tr class="texture font-size-12">
      <th colspan="2" class="text-right">Less than 4 months</th>
      <th colspan="2" class="text-right">Above 4 months</th>
      <th colspan="2" class="text-right">Above 1 year</th>
    </tr>
    <tr class="texture font-size-12">
      <th class="text-right">No.</th>
      <th class="text-right">Amt.</th>
      <th class="text-right">No.</th>
      <th class="text-right">Amt.</th>
      <th class="text-right">No.</th>
      <th class="text-right">Amt.</th>
      <th class="text-right">No.</th>
      <th class="text-right">Amt.</th>
      <th class="text-right">No.</th>
      <th class="text-right">Amt.</th>
      <th class="text-right">No.</th>
      <th class="text-right">Amt.</th>
      <th class="text-right">No.</th>
      <th class="text-right">Amt.</th>
    </tr>

    <tr *ngFor="let c of rows; let i = index">
      <td class="text-center">{{ i + 1 }}.</td>
      <td>{{ formatMonth(c.month) }}</td>

      <td class="text-right">{{ c.overdue_No }}</td>
      <td class="text-right">{{ c.overdue_Amt | number:'1.2-2' }}</td>

      <td class="text-right">{{ c.fresh_No }}</td>
      <td class="text-right">{{ c.fresh_Amt | number:'1.2-2' }}</td>

      <td class="text-right">{{ c.decided_No }}</td>
      <td class="text-right">{{ c.decided_Amt | number:'1.2-2' }}</td>

      <td class="text-right">{{ c.balance_No }}</td>
      <td class="text-right">{{ c.balance_Amt | number:'1.2-2' }}</td>

      <td class="text-right">{{ c.pendency_Below4_No }}</td>
      <td class="text-right">{{ c.pendency_Below4_Amt | number:'1.2-2' }}</td>

      <td class="text-right">{{ c.pendency_4to12_No }}</td>
      <td class="text-right">{{ c.pendency_4to12_Amt | number:'1.2-2' }}</td>

      <td class="text-right">{{ c.pendency_Above1_No }}</td>
      <td class="text-right">{{ c.pendency_Above1_Amt | number:'1.2-2' }}</td>

      <td class="text-center no-wrap">
        <div class="d-flex gap-1 align-items-center">
          <button type="button" class="btn btn-primary btn-sm" title="Click to Edit">
            <i class="fa fa-pencil-square-o"></i>
          </button>
          <button type="button" class="btn btn-success btn-sm" title="Click to Verify">
            <i class="fa fa-check-square-o"></i>
          </button>
          <button type="button" class="btn btn-danger btn-sm" title="Click to Delete">
            <i class="fa fa-trash-o"></i>
          </button>
        </div>
      </td>
    </tr>
  </tbody>
</table> -->

                        <!-- 
                        <ngx-datatable 
  class="ngx-datatable billdata colored-header sm table-striped table-hover"
  [rows]="rows"
  [columnMode]="'force'"
  [headerHeight]="60"
  [footerHeight]="50"
  [rowHeight]="'auto'">

  <ngx-datatable-column name="S. N." [width]="60">
    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
      {{ rowIndex + 1 }}
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Month">
    <ng-template let-row="row" ngx-datatable-cell-template>
      {{ formatMonth(row.month) }}
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Overdue (No.)" prop="overdue_No"></ngx-datatable-column>
  <ngx-datatable-column name="Overdue (Amt.)" prop="overdue_Amt"></ngx-datatable-column>

  <ngx-datatable-column name="Fresh Cases (No.)" prop="fresh_No"></ngx-datatable-column>
  <ngx-datatable-column name="Fresh Cases (Amt.)" prop="fresh_Amt"></ngx-datatable-column>

  <ngx-datatable-column name="Decided Cases (No.)" prop="decided_No"></ngx-datatable-column>
  <ngx-datatable-column name="Decided Cases (Amt.)" prop="decided_Amt"></ngx-datatable-column>

  <ngx-datatable-column name="Balance (No.)" prop="balance_No"></ngx-datatable-column>
  <ngx-datatable-column name="Balance (Amt.)" prop="balance_Amt"></ngx-datatable-column>

  <ngx-datatable-column name="Pendency < 4m (No.)" prop="pendency_Below4_No"></ngx-datatable-column>
  <ngx-datatable-column name="Pendency < 4m (Amt.)" prop="pendency_Below4_Amt"></ngx-datatable-column>

  <ngx-datatable-column name="Pendency 4-12m (No.)" prop="pendency_4to12_No"></ngx-datatable-column>
  <ngx-datatable-column name="Pendency 4-12m (Amt.)" prop="pendency_4to12_Amt"></ngx-datatable-column>

  <ngx-datatable-column name="Pendency > 1yr (No.)" prop="pendency_Above1_No"></ngx-datatable-column>
  <ngx-datatable-column name="Pendency > 1yr (Amt.)" prop="pendency_Above1_Amt"></ngx-datatable-column>

  <ngx-datatable-column name="Action" [width]="160">
    <ng-template let-row="row" ngx-datatable-cell-template>
      <div class="d-flex gap-1">
        <button class="btn btn-primary btn-sm"><i class="fa fa-pencil-square-o"></i></button>
        <button class="btn btn-success btn-sm"><i class="fa fa-check-square-o"></i></button>
        <button class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i></button>
      </div>
    </ng-template>
  </ngx-datatable-column>

</ngx-datatable> -->

                    </div>
                </div>
            </div>
        </div>


    </div>
</div>

<!-- Read More Model -->
<div class="modal fade animate-fade" id="readMoreModal" tabindex="-1" aria-labelledby="readMoreModalLabel"
    aria-hidden="true">
    <div class="modal-dialog   modal-lg modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="readMoreModalLabel">📄 Add Arbitration Cases Data</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="col-lg-12">


                    <div class="card-body">
                        <form [formGroup]="arbitrationForm" (ngSubmit)="onSubmit()">
                            <div class="row align-items-end">

                                <!-- Financial/Reporting Year -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Financial/Reporting Year<span
                                            class="text-danger">*</span></label>
                                    <input type="text" class="form-control" formControlName="financialYear" />
                                    <div class="text-danger small" style="min-height: 1.25rem;">
                                        <span
                                            *ngIf="arbitrationForm.get('financialYear')?.touched && arbitrationForm.get('financialYear')?.invalid">
                                            Financial Year is required
                                        </span>
                                    </div>
                                </div>

                                <!-- Block Office -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Block Office<span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="blockOffice">
                                        <option value="" selected>--Select--</option>
                                        <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                            {{ circle?.sBlockName }}
                                        </option>
                                    </select>
                                    <div class="text-danger small" style="min-height: 1.25rem;">
                                        <span
                                            *ngIf="arbitrationForm.get('blockOffice')?.touched && arbitrationForm.get('blockOffice')?.invalid">
                                            Block Office is required
                                        </span>
                                    </div>
                                </div>

                                <!-- Data For Month -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Data For Month<span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="dataMonth">
                                        <option value="" selected>--Select--</option>
                                        <option *ngFor="let circle of monthList" [value]="circle?.id">
                                            {{ circle?.name }}
                                        </option>
                                    </select>
                                    <div class="text-danger small" style="min-height: 1.25rem;">
                                        <span
                                            *ngIf="arbitrationForm.get('dataMonth')?.touched && arbitrationForm.get('dataMonth')?.invalid">
                                            Month is required
                                        </span>
                                    </div>
                                </div>

                                <!-- Cases as on Start -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Cases as on 01 {{ currentMonth?.name }}</label>
                                    <input type="number" min="0" step="1" class="form-control"
                                        formControlName="casesAsOnStart" />
                                    <div class="text-danger small"
                                        *ngIf="arbitrationForm.get('casesAsOnStart')?.touched && arbitrationForm.get('casesAsOnStart')?.invalid"
                                        style="min-height: 1.25rem;"> Enter Valid Number</div>
                                </div>

                                <!-- Fresh Cases -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">No. of Fresh Cases</label>
                                    <input type="number" class="form-control" min="0" step="1"
                                        formControlName="freshCases" />
                                    <div class="text-danger small"
                                        *ngIf="arbitrationForm.get('freshCases')?.touched && arbitrationForm.get('freshCases')?.invalid"
                                        style="min-height: 1.25rem;">Enter Valid Number</div>
                                </div>

                                <!-- Decided Cases -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">No. of Cases Decided</label>
                                    <input type="number" class="form-control" min="0" step="1"
                                        formControlName="decidedCases" />
                                    <div class="text-danger small" style="min-height: 1.25rem;"
                                        *ngIf="arbitrationForm.get('decidedCases')?.touched && arbitrationForm.get('decidedCases')?.invalid">
                                        Enter Valid Number</div>
                                </div>

                                <!-- Amount as on Start -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Amount corresponding to Cases as on Start</label>
                                    <input type="number" class="form-control" min="0" step="1"
                                        formControlName="amountAsOnStart" />
                                    <div class="text-danger small" style="min-height: 1.25rem;"
                                        *ngIf="arbitrationForm.get('amountAsOnStart')?.touched && arbitrationForm.get('amountAsOnStart')?.invalid">
                                        Enter Valid Amount</div>
                                </div>

                                <!-- Amount for Fresh Cases -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Amount for Fresh Cases</label>
                                    <div class="input-group">
                                        <span class="input-group-text">₹</span>
                                        <input type="number" class="form-control" min="0" step="1"
                                            formControlName="freshCasesAmount" />
                                        <span class="input-group-text">.00</span>
                                    </div>
                                    <div class="text-danger small" style="min-height: 1.25rem;"
                                        *ngIf="arbitrationForm.get('freshCasesAmount')?.touched && arbitrationForm.get('freshCasesAmount')?.invalid">
                                        Enter Valid Amount</div>
                                </div>

                                <!-- Amount for Decided Cases -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Amount for Decided Cases</label>
                                    <div class="input-group">
                                        <span class="input-group-text">₹</span>
                                        <input type="number" class="form-control" min="0" step="1"
                                            formControlName="decidedCasesAmount" />
                                        <span class="input-group-text">.00</span>
                                    </div>
                                    <div class="text-danger small" style="min-height: 1.25rem;"
                                        *ngIf="arbitrationForm.get('decidedCasesAmount')?.touched && arbitrationForm.get('decidedCasesAmount')?.invalid">
                                        Enter Valid Amount</div>
                                </div>

                                <!-- Pendency Table -->
                                <div class="col-lg-12">
                                    <label class="form-label">Pendency of Remaining Cases</label>
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                     <th>S.No.</th>
                                                    <th>Pendency</th>
                                                    <th>No.</th>
                                                    <th>Amt</th>
                                                </tr>
                                            </thead>
                                            <tbody formArrayName="pendencyList">
                                                <tr *ngFor="let p of pendencyList.controls; let i = index"
                                                    [formGroupName]="i">
                                                    <td>{{ i + 1 }}</td>
                                                    <td>
                                                        <input type="text" class="form-control"
                                                            formControlName="pendencyCategory" readonly />
                                                    </td>
                                                    <td>
                                                        <input type="number" class="form-control" min="0" step="1"
                                                            formControlName="noOfCases" />
                                                        <div class="text-danger small" style="min-height: 1.25rem;"
                                                            *ngIf="arbitrationForm.get('noOfCases')?.touched && arbitrationForm.get('noOfCases')?.invalid">
                                                            Enter valid Number</div>
                                                    </td>
                                                    <td>
                                                        <div class="input-group">
                                                            <span class="input-group-text">₹</span>
                                                            <input type="number" class="form-control" min="0" step="1"
                                                                formControlName="amount" />
                                                            <span class="input-group-text">.00</span>
                                                        </div>
                                                        <div class="text-danger small" style="min-height: 1.25rem;"
                                                            *ngIf="arbitrationForm.get('amount')?.touched && arbitrationForm.get('amount')?.invalid">
                                                            Enter Valid Number</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- Submit Button -->
                                <!-- <div class="col-lg-12 text-end mt-3">
                                    <button type="submit" class="btn btn-primary" [disabled]="arbitrationForm.invalid">
                                        Submit
                                    </button>
                                </div> -->

                            </div>
                        </form>
                    </div>


                </div>
            </div>
            <div class="modal-footer">
                <div class="col-lg-12 text-end">
                    <div class="d-flex align-items-center justify-content-end gap-2">
                        <button type="button" class="btn btn-secondary" (click)="hideModal($event)">Back</button>
                        <button type="submit" class="btn btn-primary" [disabled]="arbitrationForm.invalid"
                            (click)="onSubmit()">Save</button>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>